import { message, Select } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ModalItem, ButtonItem } from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import procesosQrPdf from "../../../../Pdf/procesosQrPdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const OPCIONES_QR_POR_HOJA = [1, 2, 4, 6, 8, 10];

class ModalQRPrograma extends Component {
  state = { loading: false, qrPorHoja: 1, datosPdf: null };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      this.setState({ datosPdf: null }, () => this.cargarPdf());
    }
    if (this.props.visible !== prevProps.visible && !this.props.visible) {
      this.setState({ datosPdf: null, qrPorHoja: 1 });
    }
  }

  async obtenerDatosPdf() {
    if (this.state.datosPdf) return this.state.datosPdf;

    const resDatos = await axios.post(
      "programa/datosPdfPrograma",
      { programaId: this.props.programaId, empresaId: this.props.empresaId },
      { headers: this.props.headersToken }
    );

    if (resDatos.data.success !== 2) return null;

    const { procesos = [], empresa, ...programa } = resDatos.data.data;

    const tokenEntries = await Promise.all(
      procesos.map(async (proc) => {
        try {
          const res = await axios.post(
            "programa/generarTokenQRProceso",
            {
              empresaId:  this.props.empresaId,
              procesoId:  proc._id,
              programaId: this.props.programaId,
            },
            { headers: this.props.headersToken }
          );
          if (res.data.success === 2) {
            return [proc._id.toString(), res.data.token];
          }
        } catch {
          // proceso sin token — se muestra sin QR
        }
        return null;
      })
    );

    const tokens = Object.fromEntries(tokenEntries.filter(Boolean));
    const datosPdf = { programa, procesos, empresa, tokens };
    this.setState({ datosPdf });
    return datosPdf;
  }

  async cargarPdf() {
    this.setState({ loading: true });
    try {
      const datosPdf = await this.obtenerDatosPdf();
      if (!datosPdf) {
        message.warning("No se pudo cargar el programa");
        this.props.onCancel();
        return;
      }

      const dd = await procesosQrPdf({ ...datosPdf, qrPorHoja: this.state.qrPorHoja });
      pdfMake.createPdf(dd).open({}, window.frames["qrPdfFrame"]);
    } catch (err) {
      console.error("❌ ModalQRPrograma:", err);
      message.error("Error al generar las tarjetas QR");
      this.props.onCancel();
    } finally {
      this.setState({ loading: false });
    }
  }

  async descargar() {
    this.setState({ loading: true });
    try {
      const datosPdf = await this.obtenerDatosPdf();
      if (!datosPdf) {
        message.warning("No se pudo cargar el programa");
        return;
      }

      const dd = await procesosQrPdf({ ...datosPdf, qrPorHoja: this.state.qrPorHoja });
      pdfMake.createPdf(dd).download(`QR Procesos - ${datosPdf.programa.nombre || "programa"}.pdf`);
    } catch (err) {
      console.error("❌ ModalQRPrograma descargar:", err);
      message.error("Error al descargar el PDF");
    } finally {
      this.setState({ loading: false });
    }
  }

  onCambiarQrPorHoja(value) {
    this.setState({ qrPorHoja: value }, () => this.cargarPdf());
  }

  render() {
    const { visible, onCancel } = this.props;
    const { loading } = this.state;

    return (
      <ModalItem
        title="Tarjetas QR de Procesos"
        visible={visible}
        spinning={loading}
        onCancel={onCancel}
        paddingTop
        width={900}
      >
        <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 8, marginBottom: 12 }}>
          <span style={{ fontSize: 12, color: "#666" }}>QR por hoja:</span>
          <Select
            size="small"
            style={{ width: 80 }}
            value={this.state.qrPorHoja}
            disabled={loading}
            onChange={(value) => this.onCambiarQrPorHoja(value)}
          >
            {OPCIONES_QR_POR_HOJA.map((n) => (
              <Select.Option key={n} value={n}>{n}</Select.Option>
            ))}
          </Select>
          <ButtonItem blanco loading={loading} onClick={this.descargar.bind(this)}>
            Descargar PDF
          </ButtonItem>
          <ButtonItem danger onClick={onCancel}>
            Cerrar
          </ButtonItem>
        </div>
        <iframe
          title="QR Procesos PDF"
          id="qrPdfFrame"
          name="qrPdfFrame"
          style={{ width: "100%", height: "80vh", border: "none" }}
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId:    state.empresa.id,
});

export default connect(mapStateToProps)(ModalQRPrograma);
